"use client";
import "../chunk-N3ETBM74.js";
import { jsx } from "react/jsx-runtime";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { msalAuthSettings } from "../msal";
import { stashPostLoginTarget } from "../postLoginTarget";
const LoginButton = ({ text, locale }) => {
  const { inProgress, instance } = useMsal();
  const handleLogin = async () => {
    if (inProgress !== InteractionStatus.None) return;
    const redirect = `${window.location.pathname}${window.location.search}`;
    stashPostLoginTarget(redirect);
    await instance.loginRedirect({
      redirectUri: msalAuthSettings.config.auth.redirectUri,
      extraQueryParameters: { ui_locales: locale },
      scopes: msalAuthSettings.scopes
    });
  };
  return /* @__PURE__ */ jsx("div", { className: "w-full", "data-e2e-login": true, children: /* @__PURE__ */ jsx(
    "button",
    {
      className: "font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle text-pretty text-primitive-16 leading-primitive-24 md:text-primitive-16 md:leading-primitive-24 lg:text-primitive-16 lg:leading-primitive-24 disabled:text-semantic-global-disabled-default on-dark:disabled:text-semantic-global-disabled-dark py-semantic-global-xs px-semantic-global-md bg-semantic-global-primary-default on-dark:bg-semantic-global-primary-default text-semantic-global-text-lightest on-dark:text-semantic-global-text-lightest hover:bg-semantic-global-primary-dark on-dark:hover:bg-semantic-global-primary-dark active:bg-semantic-global-primary-darker on-dark:active:bg-semantic-global-primary-darker disabled:bg-semantic-global-disabled-light on-dark:disabled:bg-semantic-global-disabled-darker gap-semantic-global-xs flex w-full cursor-pointer flex-row items-center justify-center",
      disabled: inProgress !== InteractionStatus.None,
      onClick: handleLogin,
      type: "button",
      children: text
    }
  ) });
};
var LoginButton_default = LoginButton;
export {
  LoginButton_default as default
};
